<div mat-dialog-content>
  <video id="video-dashboard" [autoplay]="true" [muted]="false" [loop]="false" class="video-dashboard" (ended)="closeDialog()" controls preload="metadata">
    <source src="../../../assets/media/mobil_assistance_plataforma_9.0 (1080p).mp4" type="video/mp4">
    
    <track label="Spanish" kind="captions" srclang="es" src="../../../assets/media/MOBIL ASSISTANCE PLATAFORMA.srt" default>
  </video>
</div>